import React from 'react';
import { ThemeProvider } from '@material-ui/core';
import Theme from './Theme';
import './App.css';
import RootContainer from './components/RootContainer';
import store from './redux/store';
import { Provider } from 'react-redux';

/* 
    Intro point for the form
*/
function App() {
  return (
    <>
      {/* Theme provider for the form */}
      <Provider store={store}>
        <ThemeProvider theme={Theme}>
          <RootContainer />
        </ThemeProvider>
      </Provider>
    </>
  );
}

export default App;
